import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Romii", href: "#romii" },
  { label: "Vision", href: "#vision" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-white/75 border-b border-gray-100/70 shadow-[0_4px_24px_rgb(0,0,0,0.03)]"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="main-navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo-link" className="flex items-center">
          <img
            src="/assets/huminence-wordmark-green.png"
            alt="Huminence Technologies"
            className="h-8 sm:h-9 w-auto"
          />
        </a>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-base font-medium text-gray-500 hover:text-[#111827] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#contact"
            data-testid="nav-cta-demo"
            className="inline-flex items-center rounded-full bg-[#7F9F43] px-6 py-3 text-base font-semibold text-white hover:bg-[#6e8b39] transition-colors duration-300"
          >
            Request a Demo
          </a>
        </div>

        <button
          className="md:hidden p-2 text-gray-700"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden backdrop-blur-xl bg-white/95 border-b border-gray-100 px-6 pb-6 pt-2 space-y-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base font-medium text-gray-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="inline-flex rounded-full bg-[#7F9F43] px-5 py-2.5 text-sm font-semibold text-white"
          >
            Request a Demo
          </a>
        </div>
      )}
    </motion.header>
  );
}
